import axios from 'axios';
import config from '../config/apiConfig';

const authHeaders = () => {
    const token = localStorage.getItem("token");
    if (!token) throw new Error("Token no disponible.");
    return { headers: { token } };
};

// ------------------------------------------------------------------
// Insumos
// ------------------------------------------------------------------

export const obtenerInsumos = async () => {
    const resp = await axios.get(`${config.api_url}/api/insumos`, authHeaders());
    return resp.data;
};

export const guardarInsumo = async (insumoData) => {
    const id = insumoData.id;
    const url = id ? `/api/insumos/${id}` : '/api/insumos';
    const method = id ? 'put' : 'post';
    const resp = await axios[method](`${config.api_url}${url}`, insumoData, authHeaders());
    return resp.data;
};

export const eliminarInsumo = async (id) => {
    const resp = await axios.delete(`${config.api_url}/api/insumos/${id}`, authHeaders());
    return resp.data;
};

export const ajusteRapidoStockInsumo = async (id, nuevoStock, motivo) => {
    const resp = await axios.put(`${config.api_url}/api/insumos/${id}/stock_rapido`, { stock: nuevoStock, motivo }, authHeaders());
    return resp.data;
};

// ------------------------------------------------------------------
// Categorías de Insumos
// ------------------------------------------------------------------

export const obtenerCategoriasInsumos = async () => {
    const resp = await axios.get(`${config.api_url}/api/categorias_insumos`, authHeaders());
    return resp.data;
};

export const guardarCategoriaInsumo = async (categoriaData) => {
    const id = categoriaData.id;
    const url = id ? `/api/categorias_insumos/${id}` : '/api/categorias_insumos';
    const method = id ? 'put' : 'post';
    const resp = await axios[method](`${config.api_url}${url}`, categoriaData, authHeaders());
    return resp.data;
};

export const eliminarCategoriaInsumo = async (id) => {
    const resp = await axios.delete(`${config.api_url}/api/categorias_insumos/${id}`, authHeaders());
    return resp.data;
};
